export const PAYROLL_API = {
  GET_SALARY_STRUCTURE_LIST: "salary-structure",
  EXPORT_SALARY_STRUCTURES: "salary-structure/export",
  GET_SALARY_STRUCTURE_BY_ID: "salary-structure/",
  CREATE_SALARY_STRUCTURE: "salary-structure/create",
  UPDATE_SALARY_STRUCTURE: (id: number) => `salary-structure/${id}/update`,
  DELETE_SALARY_STRUCTURE: (id: number) => `salary-structure/${id}/delete`,
  ASSIGN_SALARY_STRUCTURE: (id: number) => `salary-structure/${id}/assign-employees`,
  UNASSIGN_SALARY_STRUCTURE: (salary_structure_id: number) =>
    `salary-structure/${salary_structure_id}/unassign-employees`,

  PAYROLL_DEFINITION_LIST: "payrolls",
  EXPORT_PAYROLL_DEFINITION: "payrolls/export",
  CREATE_PAYROLL_DEFINITION: "payrolls/create",
  UPDATE_PAYROLL_DEFINITION: (id: number) => `payrolls/${id}/update`,
  GET_PAYROLL_DEFINITION_BY_ID: "payrolls/",

  ELEMENT_BATCH_LIST: "element-batches",
  EXPORT_ELEMENT_BATCHES: "element-batches/export",
  CREATE_ELEMENT_BATCH: "element-batches/create",
  UPDATE_ELEMENT_BATCH: (id: number) => `element-batches/${id}/update`,
  GET_ELEMENT_BATCH_BY_ID: "element-batches/",

  EMPLOYEE_BATCH_LIST: "employee-batches",
  EXPORT_EMPLOYEE_BATCHES: "employee-batches/export",
  CREATE_EMPLOYEE_BATCH: "employee-batches/create",
  UPDATE_EMPLOYEE_BATCH: (id: number) => `employee-batches/${id}/update`,
  GET_EMPLOYEE_BATCH_BY_ID: "employee-batches/",

  GET_BATCHES_MANAGEMENT_LIST: "payroll-batches/",
  GET_ASSIGNED_EMPLOYEES_LIST: (id: number) => `payroll-batches/${id}/employees`,
  CREATE_BATCHES_MANAGEMENT: "payroll-batches/create",
  UPDATE_BATCHES_MANAGEMENT: (id: number) => `payroll-batches/${id}/update`,
  ASSIGN_EMPLOYEES_TO_BATCH: (id: number) => `payroll-batches/${id}/assign-employees`,
  GET_BATCH_DETAILS: `payroll-batches/`,
  UNASSIGN_EMPLOYEES_FROM_BATCH: (id: number) => `payroll-batches/${id}/unassign-employees`,

  TAX_RULES_LIST: "tax-rule",
  EXPORT_TAX_RULES: "tax-rule/export",
  CREATE_TAX_RULE: "tax-rule/create",
  GET_TAX_RULE_BY_ID: "tax-rule/",
  UPDATE_TAX_RULE: (id: number) => `tax-rule/${id}/update`,

  GET_BANK_LIST: "banks",
  EXPORT_BANKS: "banks/export",
  EXPORT_BANK_TEMPALTE: (bank_id: number) =>
    `banks/${bank_id}/employee-payment-assignment-template`,
  UPLOAD_BANKS_EMPLOYEE_ASSIGNMENT_TEMPLATE: (bank_id: number) =>
    `banks/${bank_id}/employee-payment-assignment`,
  GET_BANK_BY_ID: "banks/",
  GET_PREDEFINED_BANK_LIST: "lookups/predefined-banks/",
  CREATE_BANK: "banks/create",
  UPDATE_BANK: (id: number) => `banks/${id}/update`,
  DELETE_BANK: (id: number) => `banks/${id}/delete`,
  DELETE_BANK_BRANCH: (bankId: number, BranchId: number) =>
    `banks/${bankId}/branches/${BranchId}/delete`,

  GET_EXCHANGE_RATE_LIST: "exchange-rates",
  EXPORT_EXCHANGE_RATES: "exchange-rates/export",
  GET_EXCHANGE_RATE_BY_ID: "exchange-rates/",
  CREATE_EXCHANGE_RATE: "exchange-rates/create",
  UPDATE_EXCHANGE_RATE: (id: number) => `exchange-rates/${id}/update`,
  DELETE_EXCHANGE_RATE: (id: number) => `exchange-rates/${id}/delete`,

  GET_PAYROLL_RUN_LIST: "payroll-runs",
  EXPORT_PAYROLL_RUNS: "payroll-runs/export",
  GET_PAYROLL_RUN_BY_ID: "payroll-runs/",
  EXPORT_PAYROLL_RUN_BY_ID: (id: number) => `payroll-runs/${id}/report`,
  GET_PAYSLIP: "payroll-runs/payslip",
  CREATE_PAYROLL_RUN: "payroll-runs/create",
  CANCEL_REQUEST_OF_PAYROLL_RUN: "self-services/cancel-requests/",
  CHECK_PAYROLL_RUN_STATUS: "payroll-runs/result",
  FINALIZE_PAYROLL_RUN: (id: number) => `payroll-runs/${id}/finalize`,
  DELETE_PAYROLL_RUN: (id: number) => `payroll-runs/${id}/delete`,

  GET_SOCIAL_INSURANCE_LIST: "social-insurance",
  EXPORT_SOCIAL_INSURANCES: "social-insurance/export",
  GET_SOCIAL_INSURANCE_BY_ID: "social-insurance/",
  CREATE_SOCIAL_INSURANCE: "social-insurance/create",
  UPDATE_SOCIAL_INSURANCE: (id: number) => `social-insurance/${id}/update`,
  DELETE_SOCIAL_INSURANCE: (id: number) => `social-insurance/${id}/delete`,
  DELETE_SOCIAL_INSURANCE_SHARE: (id: number, shareId: number) =>
    `social-insurance/${id}/share/${shareId}/delete`,

  CREATE_PAYROLL_ELEMENT: "elements/create",
  GET_PAYROLL_ELEMENT_BY_ID: "elements/",
  UPDATE_PAYROLL_ELEMENT_BY_ID: (id: number) => `elements/${id}/update`,
  DELETE_PAYROLL_ELEMENT_BY_ID: (id: number) => `elements/${id}/delete`,
  GET_PAYROLL_ELEMENT_LIST: "elements",
  EXPORT_PAYROLL_ELEMENT: "elements/export",

  //CLOSING SALARY REPORT
  CLOSING_SALARY_REPORTS: "reports/closing-salary-reports",
  ARCHIVED_CLOSING_SALARY_REPORTS: "reports/closing-salary-reports/archived",
  CLOSING_SALARY_REPORT_DETAILS: (id: number) => `reports/closing-salary-reports/${id}`,
  CLOSING_SALARY_REPORTS_TAKE_ACTION: (id: number) =>
    `reports/closing-salary-reports/${id}/take-action`,
};
